import { ButtonBase, Chip, Stack, SxProps, Theme, Typography } from '@mui/material';
import { DynamicIcon } from 'src/components';
import { Conversation, getStatusDisplay } from 'src/graphql';
import { MergeTargetSuggestion } from './suggestions.types';

interface SuggestionRowProps {
  suggestion: MergeTargetSuggestion;
  statusLabel: string;
  onSelect: (conversation: Conversation) => void;
}

const rowSx: SxProps<Theme> = {
  width: '100%',
  justifyContent: 'flex-start',
  textAlign: 'start',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1,
  px: 1.5,
  py: 1.25,
  '&:hover': {
    backgroundColor: 'action.hover',
  },
};

export const SuggestionRow = ({ suggestion, statusLabel, onSelect }: SuggestionRowProps) => {
  const statusProps = getStatusDisplay(suggestion.statusId);

  const metaParts = [suggestion.date, suggestion.requesterName].filter(Boolean).join(' · ');

  return (
    <ButtonBase sx={rowSx} onClick={() => onSelect(suggestion.conversation)}>
      <Stack direction="row" gap={1.5} alignItems="center" width="100%" minWidth={0}>
        <Chip label={suggestion.friendlyId} size="small" />
        <Stack minWidth={0} flexGrow={1}>
          <Stack direction="row" gap={0.5} alignItems="center" minWidth={0}>
            <Typography variant="caption" color="text.secondary" noWrap>
              {metaParts}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              ·
            </Typography>
            <Stack direction="row" gap={1} alignItems="center">
              <DynamicIcon
                name={statusProps.icon}
                library={statusProps.library}
                aria-label={suggestion.statusId}
                sx={{ color: statusProps.color, width: '1rem', height: '1rem' }}
              />
              <Typography variant="caption" color="text.secondary" noWrap>
                {statusLabel}
              </Typography>
            </Stack>
          </Stack>
          <Typography variant="body2" color="text.primary" noWrap>
            {suggestion.subject}
          </Typography>
        </Stack>
      </Stack>
    </ButtonBase>
  );
};
